import React, { useEffect, useState } from "react";
import db from "../../Utils/firebase";
import { Link } from "react-router-dom";
import { showLoader, hideLoader } from "../../components/common/Loader";
import { FaCheckCircle, FaCalendarAlt, FaBrain, FaApple, FaAndroid, FaReact } from "react-icons/fa";

// const stats = [
//   {
//     id: 1,
//     icon: <FaCheckCircle className="text-gray-700 text-lg" />,
//     value: "40+",
//     label: "Projects Delivered",
//     position: "top-left",
//     color: "bg-cream", // #FFF4CC
//     textColor: "text-gray-800"
//   },
//   {
//     id: 2,
//     icon: <FaCalendarAlt className="text-gray-700 text-lg" />,
//     value: "7+",
//     label: "Years Experience",
//     position: "top-right",
//     color: "bg-pale-orange", // #FFD4B3
//     textColor: "text-gray-800"
//   },
//   {
//     id: 3,
//     icon: <FaBrain className="text-gray-700 text-lg" />,
//     value: "AI",
//     label: "Assisted Development",
//     position: "bottom-right", // Changed to bottom right of image
//     color: "bg-pale-teal", // #CCF2F4
//     textColor: "text-gray-800"
//   },
// ];

const StatCard = ({ icon, value, label, position, color, textColor }) => {
  const colorMap = {
    "bg-cream": "#FFF4CC",
    "bg-pale-orange": "#FFD4B3",
    "bg-pale-teal": "#CCF2F4"
  };

  const positionClasses = {
    "top-left": "absolute -left-4 top-10 md:-left-12 md:top-12 xl:-left-20",
    "top-right": "absolute -right-4 top-28 md:-right-16 md:top-28 xl:-right-24",
    "bottom-right": "absolute -right-2 bottom-4 md:-right-10 md:bottom-10 xl:-right-20", 
  };

  return (
    <div
      className={`${positionClasses[position]} ${textColor}
      px-4 py-3 rounded-xl shadow-2xl flex flex-col items-start min-w-[140px]
      transform transition hover:-translate-y-1 duration-300`}
      style={{ 
        backgroundColor: colorMap[color] || '#ffffff', 
        zIndex: 50,
        opacity: 1 
      }}
    >
        <div className="mb-1">{icon}</div>
        <div className="text-xl font-bold leading-none mb-1">{value}</div>
        <div className="text-xs font-bold leading-tight">{label}</div>
    </div>
  );
};

const Intro = () => {
    // Hardcoded for display match, but kept state structure if dynamic needed later
  const [info, setInfo] = useState({
    userName: "Gopi Kachhadiya.",
    // location: "Based in India · Working with global clients", // Moved to static text
  });

  useEffect(() => {
    // Skipping loader for now to prevent flash? Or keeping it.
    // showLoader();
    // Assuming data fetching is still needed, keeping effect
  }, []);

  return (
    <section className="min-h-screen bg-[#0E1012] flex items-center justify-center overflow-hidden relative">
        {/* Background Glows */}
        <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] bg-brand-orange/10 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-6 py-20 relative z-10">
          {/* CONTENT CONTAINER */}
          <div className="flex flex-col items-center lg:items-start lg:flex-row lg:justify-center gap-10 lg:gap-28">
            
            {/* MOBILE HEADER - Only visible on mobile/tablet */}
            <div className="lg:hidden text-center space-y-4">
                <div>
                    <p className="text-gray-400 text-lg mb-2">
                    Hi, I’m <span className="text-gray-200">{info.userName}</span>
                    </p>
                    <div className="text-5xl md:text-6xl font-bold text-white leading-tight tracking-tight">
                    Senior React Native & Expo Developer
                    </div>
                </div>
            </div>

            {/* UPWORK BADGE SECTION */}
            <div className="relative">
               {/* Background Multi-Shade Glow (Behind the image) */}
               <div className="absolute inset-x-[-20%] inset-y-[-10%] z-0 pointer-events-none scale-110">
                  <div className="absolute top-1/4 -left-10 w-72 h-72 bg-[#FF9C40]/40 rounded-full blur-[100px] animate-pulse-slow" />
                  <div className="absolute bottom-0 -right-10 w-80 h-80 bg-primary/30 rounded-full blur-[110px]" />
                  <div className="absolute -top-10 right-1/4 w-64 h-64 bg-purple-500/20 rounded-full blur-[90px]" />
                </div>

              <div 
                className="relative w-72 sm:w-80 md:w-96 lg:w-[420px] xl:w-[480px] flex flex-col items-center"
              >
                  <div className="relative w-full overflow-hidden rounded-2xl z-20 ">
                    <img
                      src="/assets/images/intro/upworkbadge.webp"
                      alt="Upwork Badge"
                      className="w-full h-auto object-contain p-2 relative z-10"
                    />
                  </div>

                  {/* Trusted Platform Label */}
                  <div className="mt-4 z-30 flex items-center gap-3" style={{gap:"0.5rem"}}>
                    <span className="text-xl font-bold text-gray-200 tracking-wide">
                      Trusted Platform
                    </span>

                    {/* Horizontal Divider */}
                    <div 
                      className="bg-white"
                      style={{ width: "2rem", height: "3px", position: "relative", bottom: "-0.21rem" }}
                    />

                    <a href="https://www.upwork.com/freelancers/gopih" target="_blank" rel="noopener noreferrer" className="hover:scale-105 transition-transform">
                      <img 
                          src="/assets/images/intro/upwork.webp" 
                          alt="Upwork" 
                          className="object-contain"
                          style={{ 
                              width: window.innerWidth < 768 ? "4.5rem" : "6rem", 
                              height: "auto", 
                              position: "relative", 
                              bottom: "-0.3rem" 
                          }}
                      />
                    </a>
                  </div>
              </div>
            </div>

            {/* MAIN CONTENT BLOCK */}
            <div className="max-w-xl text-center lg:text-left space-y-8">
              {/* DESKTOP HEADER - Hidden on mobile */}
              <div className="hidden lg:block">
                  <p className="text-gray-400 text-lg mb-2 pl-1">
                  Hi, I’m <span className="text-gray-200">{info.userName}</span>
                  </p>
                  <div className="text-5xl xl:text-[4rem] font-bold text-white leading-[1.1] tracking-tight">
                  Senior React Native & Expo Developer
                  </div>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-3 justify-center lg:justify-start">
                  <p className="text-gray-300 text-lg xl:text-xl leading-relaxed max-w-lg">
                    Building production-ready iOS & Android apps with AI-accelerated workflows
                  </p>
                </div>

                <p className="text-gray-500 text-sm xl:text-base font-medium">
                   Based in India · Working with global clients
                </p>
              </div>

              {/* Actions Row */}
              <div className="flex flex-col sm:flex-row sm:mt-0 mt-10 items-center gap-6 justify-center lg:justify-start">
                  {/* My Portfolio Button */}
                  <Link to="/portfolio">
                      <button className="px-8 py-3 rounded-full bg-primary text-dark font-bold hover:scale-105 transition-transform">
                          My Portfolio
                      </button>
                  </Link>

                  {/* Tech Icons */}
                  <div className="flex items-center gap-4">
                      <div className="p-2 rounded-2xl bg-[#1A1D21] border border-white/20 shadow-xl group">
                          <img src="/assets/images/intro/atom.webp" className="w-8 h-8 group-hover:scale-110 transition-transform" />
                      </div>
                      <div className="p-3 rounded-2xl bg-[#1A1D21] border border-white/20 shadow-xl group">
                          <FaApple className="text-3xl text-white group-hover:scale-110 transition-transform" />
                      </div>
                      <div className="p-3 rounded-2xl bg-[#1A1D21] border border-white/20 shadow-xl group">
                          <img src="/assets/images/intro/android1.webp" className="w-8 h-8 group-hover:scale-110 transition-transform" />
                      </div>
                  </div>
              </div>
            </div>
          </div>

      </div>
    </section>
  );
};

export default Intro;
